import React, { useContext } from 'react'
import { Context } from './Context'
import { Login } from './components/login/login'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { Payment } from './components/payment/payment';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import ReactNotifications from 'react-notifications-component'
import { Layout } from './components/shared/layout';
import FooterBar from './components/shared/footerBar/FooterBar'
import reactTableOverride from './components/table/ReactTableOverride'
import 'react-notifications-component/dist/index'
import 'react-table/react-table.css'
import './styles/App.css';

reactTableOverride();

const theme = createMuiTheme({
  typography: {
    fontFamily: '-apple-system,BlinkMacSy0stemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif',
    fontSize: 11,
    subtitle1: {
      fontSize: 16
    },
    body1: {
      fontSize: 13
    }
  },
  palette: {
    primary: {
      light: 'rgb(245, 245, 245)',
      main: 'rgb(9, 66, 124)',
      dark: '#09427C',
      contrastText: '#FFFFFF',
    },
    secondary: {
      light: '#fef5e6',
      main: '#E64B0E',
      dark: '#09427C',
      contrastText: '#FFFFFF',
    }
  }
});

const App = () => {
  const { isAuth } = useContext(Context)

  return (
    <>
      <MuiThemeProvider theme={theme}>
        <ReactNotifications />
          <BrowserRouter>
            <Layout>
              <Context.Consumer>  
                {
                  ({ isAuth }) => isAuth ?
                    <React.Fragment>
                      <Switch>
                        <Route exact path="" component={Payment} />
                        <Route exact path="/pay" component={Payment} />
                      </Switch>
                    </React.Fragment>                  
                  : 
                    <React.Fragment>
                      <Switch>
                        <Route exact path="/pay" component={Login} />
                        <Route path="" component={Login} />
                        <Route exact path="/login" component={Login} />
                      </Switch>
                      <FooterBar />
                    </React.Fragment>
                }          
              </Context.Consumer>
            </Layout>
          </BrowserRouter>
      </MuiThemeProvider>
    </>
  )
}

export default App